import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";

const GestionSocios = () => {
  const navigate = useNavigate();

  const [socios, setSocios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buscar, setBuscar] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("TODOS");
  const [filtroFacultad, setFiltroFacultad] = useState("TODAS");
  const [filtroTipoSocio, setFiltroTipoSocio] = useState("TODOS");
  const [filtroSexo, setFiltroSexo] = useState("TODOS");
  const [imprimirConCorreo, setImprimirConCorreo] = useState(true);

  const [facultadesBD, setFacultadesBD] = useState([]);

  const [mostrarModalNuevo, setMostrarModalNuevo] = useState(false);
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
  const [socioEditar, setSocioEditar] = useState(null);

  const [nuevoSocio, setNuevoSocio] = useState({
  cedula: "",
  email: "",
  nombres: "",
  apellidos: "",
  telefono: "",
  fecha_nacimiento: "",
  sexo: "",
  facultad_id: "",
  rol: "",
  tipo_socio: "GENERAL",

  // NUEVOS CAMPOS
  tiene_seguro_vida: false,
  adicionales_seguro: 0,
  paga_nucleo: false,
});

  const [alerta, setAlerta] = useState({ mostrar: false, mensaje: "", tipo: "success" });

  const handleNuevoSocioChange = (e) => {
    const { name, value } = e.target;
    setNuevoSocio((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditarChange = (e) => {
    const { name, value } = e.target;
    setSocioEditar((prev) => ({ ...prev, [name]: value }));
  };

  const mostrarAlerta = (mensaje, tipo = "success") => {
    setAlerta({ mostrar: true, mensaje, tipo });
    setTimeout(() => setAlerta({ mostrar: false, mensaje: "", tipo: "success" }), 3000);
  };

  useEffect(() => {
    const cargarSocios = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/socios");
        setSocios(response.data.socios || []);
      } catch (error) {
        console.error("Error al cargar socios:", error);
      } finally {
        setLoading(false);
      }
    };
    cargarSocios();
  }, []);

  useEffect(() => {
    const cargarFacultades = async () => {
      try {
        const response = await axios.get("/facultades");
        setFacultadesBD(response.data.facultades || []);
      } catch (error) {
        console.error("Error al cargar facultades:", error);
      }
    };
    cargarFacultades();
  }, []);

  const totalUsuarios = socios.length;
  const facultadesFiltro = ["Todas", ...new Set(socios.map((s) => s.facultad?.nombre).filter(Boolean))];

  const sociosFiltrados = socios
  .filter((socio) => {
    const palabrasBusqueda = buscar
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    const textoSocio = `
      ${socio.cedula || ""}
      ${socio.nombres || ""}
      ${socio.apellidos || ""}
    `.toLowerCase();

    const coincideBusqueda =
      palabrasBusqueda.length === 0 ||
      palabrasBusqueda.every((palabra) =>
        textoSocio.includes(palabra)
      );

    const tipoSocioActual = socio.tipo_socio || "GENERAL";

    return (
      coincideBusqueda &&
      (filtroEstado === "TODOS" || socio.estado === filtroEstado) &&
      (filtroFacultad === "TODAS" || socio.facultad?.nombre === filtroFacultad) &&
      (filtroTipoSocio === "TODOS" || tipoSocioActual === filtroTipoSocio) &&
      (filtroSexo === "TODOS" || socio.sexo === filtroSexo)
    );
  })
  .sort((a, b) => {
    const apellido = (a.apellidos || "").localeCompare(
      b.apellidos || "",
      "es",
      { sensitivity: "base" }
    );

    if (apellido !== 0) return apellido;

    return (a.nombres || "").localeCompare(
      b.nombres || "",
      "es",
      { sensitivity: "base" }
    );
  });

  const imprimirLista = () => {
    const filtrosActivos = [];
    if (filtroFacultad  !== "TODAS") filtrosActivos.push(`Facultad: ${filtroFacultad}`);
    if (filtroEstado    !== "TODOS") filtrosActivos.push(`Estado: ${filtroEstado}`);
    if (filtroTipoSocio !== "TODOS") filtrosActivos.push(`Tipo: ${filtroTipoSocio}`);
    if (filtroSexo      !== "TODOS") filtrosActivos.push(`Sexo: ${filtroSexo}`);
    if (buscar.trim())               filtrosActivos.push(`Búsqueda: "${buscar}"`);

    const subtitulo = filtrosActivos.length > 0 ? filtrosActivos.join(" · ") : "Todos los usuarios";

    const filas = sociosFiltrados.map((socio, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${socio.cedula || "—"}</td>
        <td>${socio.apellidos || ""} ${socio.nombres || ""}</td>
        ${imprimirConCorreo ? `<td>${socio.email || "—"}</td>` : ""}
      </tr>
    `).join("");

    const thCorreo = imprimirConCorreo ? `<th>Correo Electrónico</th>` : "";

    const ventana = window.open("", "_blank", "width=900,height=700");
    ventana.document.write(`
      <!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"/>
      <title>Lista de Usuarios</title>
      <style>
        * { margin:0;padding:0;box-sizing:border-box; }
        body { font-family:Arial,sans-serif;font-size:12px;color:#111;padding:24px; }
        .header { text-align:center;margin-bottom:20px;border-bottom:2px solid #198754;padding-bottom:12px; }
        .header h2 { font-size:18px;color:#198754;margin-bottom:4px; }
        .header p  { font-size:11px;color:#555; }
        .meta { display:flex;justify-content:space-between;margin-bottom:14px;font-size:11px;color:#444; }
        table { width:100%;border-collapse:collapse; }
        thead tr { background-color:#198754;color:white; }
        th { padding:8px 10px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:0.5px; }
        td { padding:7px 10px;border-bottom:1px solid #e5e5e5; }
        tr:nth-child(even) td { background-color:#f8f9fa; }
        .total { margin-top:14px;text-align:right;font-size:12px;font-weight:bold;color:#198754; }
      </style></head><body>
        <div class="header"><h2>Lista de Usuarios</h2><p>${subtitulo}</p></div>
        <div class="meta">
          <span>Generado: ${new Date().toLocaleDateString("es-EC", { day:"2-digit",month:"long",year:"numeric" })}</span>
          <span>Total: ${sociosFiltrados.length} usuarios</span>
        </div>
        <table>
          <thead><tr><th>#</th><th>Cédula</th><th>Nombre Completo</th>${thCorreo}</tr></thead>
          <tbody>${filas}</tbody>
        </table>
        <div class="total">${sociosFiltrados.length} registro(s)</div>
      </body></html>
    `);
    ventana.document.close();
    ventana.focus();
    setTimeout(() => { ventana.print(); ventana.close(); }, 300);
  };

  const guardarSocio = async () => {
  if (
    !nuevoSocio.cedula ||
    !nuevoSocio.email ||
    !nuevoSocio.nombres ||
    !nuevoSocio.apellidos ||
    !nuevoSocio.fecha_nacimiento ||
    !nuevoSocio.sexo ||
    !nuevoSocio.rol
  ) {
    mostrarAlerta("Todos los campos obligatorios deben estar completos", "danger");
    return;
  }

  // Regla de negocio: no se puede tener adicionales de seguro sin seguro de vida
  if (Number(nuevoSocio.adicionales_seguro || 0) > 0 && !nuevoSocio.tiene_seguro_vida) {
    mostrarAlerta("No puede registrar seguros adicionales si el socio no tiene seguro de vida.", "danger");
    return;
  }

  try {
    const response = await axios.post("/registro", {
      ...nuevoSocio,
      facultad_id: nuevoSocio.facultad_id ? Number(nuevoSocio.facultad_id) : null,
      adicionales_seguro: Number(nuevoSocio.adicionales_seguro || 0),
    });

    const nuevo = {
      ...nuevoSocio,
      id: response.data.usuario.id,
      estado: response.data.usuario.estado,
      facultad:
        facultadesBD.find((f) => f.id === Number(nuevoSocio.facultad_id)) ||
        null,
    };

    setSocios((prev) => [...prev, nuevo]);
    setMostrarModalNuevo(false);

    setNuevoSocio({
      cedula: "",
      email: "",
      nombres: "",
      apellidos: "",
      telefono: "",
      fecha_nacimiento: "",
      sexo: "",
      facultad_id: "",
      rol: "",
      tipo_socio: "GENERAL",
      tiene_seguro_vida: false,
      adicionales_seguro: 0,
      paga_nucleo: false,
    });

    mostrarAlerta(response.data.message || "Usuario registrado correctamente", "success");
  } catch (error) {
    mostrarAlerta(error.response?.data?.message || "Error al registrar usuario", "danger");
  }
};

  const guardarEdicionSocio = async () => {
    if (!socioEditar) return;

    // Regla de negocio: no se puede tener adicionales de seguro sin seguro de vida
    if (Number(socioEditar.adicionales_seguro || 0) > 0 && !socioEditar.tiene_seguro_vida) {
      mostrarAlerta("No puede registrar seguros adicionales si el socio no tiene seguro de vida.", "danger");
      return;
    }

    try {
      const response = await axios.put(`/socios/${socioEditar.id}`, {
        cedula: socioEditar.cedula,
        email: socioEditar.email,
        nombres: socioEditar.nombres,
        apellidos: socioEditar.apellidos,
        telefono: socioEditar.telefono,
        fecha_nacimiento: socioEditar.fecha_nacimiento,
        sexo: socioEditar.sexo,
        // ← CAMBIADO: envía null si se dejó vacío
        facultad_id: socioEditar.facultad_id ? Number(socioEditar.facultad_id) : null,
        rol: socioEditar.rol,
        tipo_socio: socioEditar.tipo_socio,

        // ← CORREGIDO: antes estos 3 campos no se enviaban al backend,
        // por eso los cambios en el modal de edición no se guardaban.
        tiene_seguro_vida: !!socioEditar.tiene_seguro_vida,
        adicionales_seguro: Number(socioEditar.adicionales_seguro || 0),
        paga_nucleo: !!socioEditar.paga_nucleo,
      });
      setSocios((prev) => prev.map((s) => (s.id === socioEditar.id ? response.data.usuario : s)));
      setMostrarModalEditar(false);
      setSocioEditar(null);
      mostrarAlerta("Usuario actualizado correctamente", "success");
    } catch (error) {
      mostrarAlerta(error.response?.data?.message || "Error al guardar cambios", "danger");
    }
  };

  const cambiarEstadoSocio = async (socio) => {
    try {
      const response = await axios.put(`/socios/${socio.id}/estado`);
      setSocios((prev) => prev.map((s) => (s.id === socio.id ? { ...s, estado: response.data.estado } : s)));
      mostrarAlerta("Estado actualizado correctamente", "success");
    } catch (error) {
      mostrarAlerta(error.response?.data?.message || "No se pudo cambiar el estado", "danger");
    }
  };

  const cambiarTipoSocio = async (socio, nuevoTipo) => {
    try {
      const response = await axios.put(`/socios/${socio.id}`, { tipo_socio: nuevoTipo });
      setSocios((prev) => prev.map((s) =>
        s.id === socio.id ? { ...s, tipo_socio: response.data.usuario.tipo_socio } : s
      ));
      mostrarAlerta("Tipo de socio actualizado", "success");
    } catch (error) {
      mostrarAlerta(error.response?.data?.message || "No se pudo cambiar el tipo", "danger");
    }
  };

  const badgeEstado = (estado) => {
    switch (estado) {
      case "ACTIVO":    return "bg-success-subtle text-success border border-success-subtle";
      case "PENDIENTE": return "bg-warning-subtle text-warning border border-warning-subtle";
      case "INACTIVO":  return "bg-secondary-subtle text-secondary border border-secondary-subtle";
      default:          return "bg-secondary-subtle text-secondary border border-secondary-subtle";
    }
  };

  const badgeTipoSocio = (tipo) => {
    switch ((tipo || "GENERAL").toUpperCase()) {
      case "GENERAL":    return "bg-primary-subtle text-primary border border-primary-subtle";
      case "JUBILADO":   return "bg-info-subtle text-info border border-info-subtle";
      case "JUBILADO B": return "bg-warning-subtle text-warning border border-warning-subtle";
      default:           return "bg-secondary-subtle text-secondary border border-secondary-subtle";
    }
  };

  return (
    <div className="container-fluid p-4 bg-light min-vh-100">

      {alerta.mostrar && (
        <div className={`alert alert-${alerta.tipo} alert-dismissible fade show shadow position-fixed`}
          style={{ top: "20px", right: "20px", zIndex: 9999, minWidth: "300px" }}>
          <div className="d-flex align-items-center">
            <i className={`bi me-2 ${alerta.tipo === "success" ? "bi-check-circle-fill" : "bi-x-circle-fill"}`}></i>
            <span>{alerta.mensaje}</span>
          </div>
          <button className="btn-close" onClick={() => setAlerta({ ...alerta, mostrar: false })}></button>
        </div>
      )}

      {/* Header */}
      <div className="card shadow-sm border-0 mb-4 border-start border-success border-4">
        <div className="card-body d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <button className="btn btn-outline-success border-0 rounded-circle" onClick={() => navigate("/DashboardSecretaria")}>
              <i className="bi bi-arrow-left-short fs-4"></i>
            </button>
            <h4 className="fw-bold mb-0 text-dark">Gestión de Socios</h4>
          </div>
          <h5 className="mb-0 text-success fw-bold">
            Total: <span className="text-dark">{sociosFiltrados.length}</span>
            {sociosFiltrados.length !== totalUsuarios && (
              <span className="text-muted fs-6 fw-normal ms-2">de {totalUsuarios}</span>
            )}
          </h5>
        </div>
      </div>

      {/* Filtros */}
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label small fw-bold text-muted text-uppercase">Búsqueda rápida</label>
              <div className="input-group">
                <span className="input-group-text bg-white border-end-0 text-muted"><i className="bi bi-search"></i></span>
                <input className="form-control border-start-0 ps-0 shadow-none" placeholder="Cédula, nombres o apellidos..." value={buscar} onChange={(e) => setBuscar(e.target.value)} />
              </div>
            </div>
            <div className="col-md-2 col-6">
              <label className="form-label small fw-bold text-muted text-uppercase">Estado</label>
              <select className="form-select shadow-none" value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                <option value="TODOS">Todos</option>
                <option value="ACTIVO">Activos</option>
                <option value="INACTIVO">Inactivos</option>
                <option value="PENDIENTE">Pendientes</option>
              </select>
            </div>
            <div className="col-md-2 col-6">
              <label className="form-label small fw-bold text-muted text-uppercase">Facultad</label>
              <select className="form-select shadow-none" value={filtroFacultad} onChange={(e) => setFiltroFacultad(e.target.value)}>
                {facultadesFiltro.map((fac, i) => (
                  <option key={i} value={fac === "Todas" ? "TODAS" : fac}>{fac}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2 col-6">
              <label className="form-label small fw-bold text-muted text-uppercase">Sexo</label>
              <select className="form-select shadow-none" value={filtroSexo} onChange={(e) => setFiltroSexo(e.target.value)}>
                <option value="TODOS">Todos</option>
                <option value="MASCULINO">Masculino</option>
                <option value="FEMENINO">Femenino</option>
                <option value="OTRO">Otro</option>
              </select>
            </div>
            <div className="col-md-2 col-6">
              <label className="form-label small fw-bold text-muted text-uppercase">Tipo Socio</label>
              <select className="form-select shadow-none" value={filtroTipoSocio} onChange={(e) => setFiltroTipoSocio(e.target.value)}>
                <option value="TODOS">Todos</option>
                <option value="GENERAL">General</option>
                <option value="JUBILADO">Jubilado</option>
                <option value="JUBILADO B">Jubilado B</option>
              </select>
            </div>
            <div className="col-md-1 d-flex gap-2 align-items-end">
              <div className="d-flex flex-column gap-1">
                <div className="form-check form-switch mb-0" style={{ fontSize: "0.75rem" }}>
                  <input className="form-check-input" type="checkbox" id="toggleCorreo"
                    checked={imprimirConCorreo} onChange={e => setImprimirConCorreo(e.target.checked)} />
                  <label className="form-check-label text-muted" htmlFor="toggleCorreo">Correo</label>
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-outline-secondary shadow-sm" title="Imprimir lista filtrada" onClick={imprimirLista}>
                    <i className="bi bi-printer-fill"></i>
                  </button>
                  <button className="btn btn-success shadow-sm" title="Nuevo usuario" onClick={() => setMostrarModalNuevo(true)}>
                    <i className="bi bi-person-plus-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla */}
      <div className="card shadow-sm border-0 overflow-hidden">
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success"></div>
              <p className="mt-2 text-muted">Cargando usuarios...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light border-bottom">
                  <tr>
                    <th className="ps-4 py-3 border-0 text-muted small text-uppercase">Identificación</th>
                    <th className="py-3 border-0 text-muted small text-uppercase">Nombre Completo</th>
                    <th className="py-3 border-0 text-muted small text-uppercase">Facultad</th>
                    <th className="py-3 border-0 text-muted small text-uppercase">Sexo</th>
                    <th className="py-3 border-0 text-muted small text-uppercase">Estado</th>
                    <th className="py-3 border-0 text-muted small text-uppercase text-center">Tipo Socio</th>
                    <th className="text-center py-3 border-0 text-muted small text-uppercase pe-4">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {sociosFiltrados.map((socio) => (
                    <tr key={socio.id}>
                      <td className="ps-4"><span className="fw-semibold text-dark">{socio.cedula}</span></td>
                      <td>
                        <div className="fw-bold text-dark">{socio.apellidos} {socio.nombres}</div>
                        <div className="small text-muted">{socio.email}</div>
                      </td>
                      <td className="small text-secondary">{socio.facultad?.nombre || "—"}</td>
                      <td><span className="badge bg-light text-dark">{socio.sexo}</span></td>
                      <td>
                        <span className={`badge rounded-pill px-3 py-2 ${badgeEstado(socio.estado)}`}>
                          {socio.estado}
                        </span>
                      </td>
                      <td className="text-center">
                        <select
                          className={`form-select form-select-sm border-0 rounded-pill px-2 text-center fw-semibold ${badgeTipoSocio(socio.tipo_socio)}`}
                          style={{ fontSize: "0.75rem", cursor: "pointer", minWidth: "110px" }}
                          value={socio.tipo_socio || "GENERAL"}
                          onChange={(e) => cambiarTipoSocio(socio, e.target.value)}
                        >
                          <option value="GENERAL">GENERAL</option>
                          <option value="JUBILADO">JUBILADO</option>
                          <option value="JUBILADO B">JUBILADO B</option>
                        </select>
                      </td>
                      <td className="text-center pe-4">
                        <div className="d-flex gap-2 justify-content-center">
                          <button className="btn btn-sm btn-outline-secondary shadow-sm" onClick={() => {
                            setSocioEditar({ ...socio, facultad_id: socio.facultad?.id || "" });
                            setMostrarModalEditar(true);
                          }}>
                            <i className="bi bi-pencil-fill"></i>
                          </button>
                          <button className={`btn btn-sm shadow-sm ${socio.estado === "ACTIVO" ? "btn-outline-danger" : "btn-success"}`}
                            onClick={() => cambiarEstadoSocio(socio)}>
                            <i className={`bi ${socio.estado === "ACTIVO" ? "bi-person-x-fill" : "bi-person-check-fill text-white"}`}></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* ==================== MODAL NUEVO ==================== */}
      {mostrarModalNuevo && (
        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-success d-flex align-items-center">
                  <i className="bi bi-person-plus-fill me-2 fs-3"></i> Nuevo Usuario
                </h5>
                <button className="btn-close shadow-none" onClick={() => setMostrarModalNuevo(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Cédula</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="cedula" value={nuevoSocio.cedula} onChange={handleNuevoSocioChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Correo Institucional</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="email" value={nuevoSocio.email} onChange={handleNuevoSocioChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Nombres</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="nombres" value={nuevoSocio.nombres} onChange={handleNuevoSocioChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Apellidos</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="apellidos" value={nuevoSocio.apellidos} onChange={handleNuevoSocioChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Fecha de Nacimiento</label>
                    <input type="date" className="form-control bg-light border-0 py-2 shadow-none" name="fecha_nacimiento" value={nuevoSocio.fecha_nacimiento} onChange={handleNuevoSocioChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Sexo</label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="sexo" value={nuevoSocio.sexo} onChange={handleNuevoSocioChange}>
                      <option value="">Seleccione sexo</option>
                      <option value="MASCULINO">Masculino</option>
                      <option value="FEMENINO">Femenino</option>
                      <option value="OTRO">Otro</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Rol</label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="rol" value={nuevoSocio.rol} onChange={handleNuevoSocioChange}>
                      <option value="">Seleccione rol</option>
                      <option value="SOCIO">SOCIO</option>
                      <option value="EMPLEADO">EMPLEADO</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    {/* ← CAMBIADO: label indica que es opcional */}
                    <label className="form-label small fw-bold text-muted">Facultad <span className="fw-normal text-muted">(opcional)</span></label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="facultad_id" value={nuevoSocio.facultad_id} onChange={handleNuevoSocioChange}>
                      <option value="">Sin facultad</option>
                      {facultadesBD.map((fac) => <option key={fac.id} value={fac.id}>{fac.nombre}</option>)}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Tipo de Socio</label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="tipo_socio" value={nuevoSocio.tipo_socio} onChange={handleNuevoSocioChange}>
                      <option value="GENERAL">General</option>
                      <option value="JUBILADO">Jubilado</option>
                      <option value="JUBILADO B">Jubilado B</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Teléfono</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="telefono" value={nuevoSocio.telefono} onChange={handleNuevoSocioChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Seguro de Vida</label>
                    <select
                      className="form-select bg-light border-0 py-2 shadow-none"
                      name="tiene_seguro_vida"
                      value={nuevoSocio.tiene_seguro_vida}
                      onChange={(e) =>
                        setNuevoSocio((prev) => ({
                          ...prev,
                          tiene_seguro_vida: e.target.value === "true",
                          // si se quita el seguro, no tiene sentido dejar adicionales > 0
                          adicionales_seguro: e.target.value === "true" ? prev.adicionales_seguro : 0,
                        }))
                      }
                    >
                      <option value="false">No</option>
                      <option value="true">Sí</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">
                      Personas adicionales (Seguro)
                    </label>
                    <input
                      type="number"
                      min="0"
                      className="form-control bg-light border-0 py-2 shadow-none"
                      name="adicionales_seguro"
                      value={nuevoSocio.adicionales_seguro}
                      disabled={!nuevoSocio.tiene_seguro_vida}
                      onChange={(e) =>
                        setNuevoSocio((prev) => ({
                          ...prev,
                          adicionales_seguro: Number(e.target.value),
                        }))
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Paga Núcleo</label>
                    <select
                      className="form-select bg-light border-0 py-2 shadow-none"
                      name="paga_nucleo"
                      value={nuevoSocio.paga_nucleo}
                      onChange={(e) =>
                        setNuevoSocio((prev) => ({
                          ...prev,
                          paga_nucleo: e.target.value === "true",
                        }))
                      }
                    >
                      <option value="false">No</option>
                      <option value="true">Sí</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-top-0 pb-4 px-4 gap-2">
                <button className="btn btn-light border px-4" onClick={() => setMostrarModalNuevo(false)}>Cancelar</button>
                <button className="btn btn-success px-4 fw-bold" onClick={guardarSocio}>Guardar Usuario</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== MODAL EDITAR ==================== */}
      {mostrarModalEditar && socioEditar && (
        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-primary d-flex align-items-center">
                  <i className="bi bi-pencil-square me-2 fs-3"></i> Editar Usuario
                </h5>
                <button className="btn-close shadow-none" onClick={() => setMostrarModalEditar(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Cédula</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="cedula" value={socioEditar.cedula || ""} onChange={handleEditarChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Correo Institucional</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="email" value={socioEditar.email || ""} onChange={handleEditarChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Nombres</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="nombres" value={socioEditar.nombres || ""} onChange={handleEditarChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Apellidos</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="apellidos" value={socioEditar.apellidos || ""} onChange={handleEditarChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Fecha de Nacimiento</label>
                    <input type="date" className="form-control bg-light border-0 py-2 shadow-none" name="fecha_nacimiento" value={socioEditar.fecha_nacimiento || ""} onChange={handleEditarChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Sexo</label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="sexo" value={socioEditar.sexo || ""} onChange={handleEditarChange}>
                      <option value="">Seleccione sexo</option>
                      <option value="MASCULINO">Masculino</option>
                      <option value="FEMENINO">Femenino</option>
                      <option value="OTRO">Otro</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Rol</label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="rol" value={socioEditar.rol || ""} onChange={handleEditarChange}>
                      <option value="">Seleccione rol</option>
                      <option value="SOCIO">SOCIO</option>
                      <option value="EMPLEADO">EMPLEADO</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    {/* ← CAMBIADO: label indica que es opcional */}
                    <label className="form-label small fw-bold text-muted">Facultad <span className="fw-normal text-muted">(opcional)</span></label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="facultad_id" value={socioEditar.facultad_id || ""} onChange={handleEditarChange}>
                      <option value="">Sin facultad</option>
                      {facultadesBD.map((fac) => (
                        <option key={fac.id} value={fac.id}>{fac.nombre}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Tipo de Socio</label>
                    <select className="form-select bg-light border-0 py-2 shadow-none" name="tipo_socio" value={socioEditar.tipo_socio || "GENERAL"} onChange={handleEditarChange}>
                      <option value="GENERAL">General</option>
                      <option value="JUBILADO">Jubilado</option>
                      <option value="JUBILADO B">Jubilado B</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Teléfono</label>
                    <input className="form-control bg-light border-0 py-2 shadow-none" name="telefono" value={socioEditar.telefono || ""} onChange={handleEditarChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Seguro de Vida</label>
                    <select
                      className="form-select bg-light border-0 py-2 shadow-none"
                      name="tiene_seguro_vida"
                      value={!!socioEditar.tiene_seguro_vida}
                      onChange={(e) =>
                        setSocioEditar((prev) => ({
                          ...prev,
                          tiene_seguro_vida: e.target.value === "true",
                          // si se quita el seguro, no tiene sentido dejar adicionales > 0
                          adicionales_seguro: e.target.value === "true" ? prev.adicionales_seguro : 0,
                        }))
                      }
                    >
                      <option value={false}>No</option>
                      <option value={true}>Sí</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">
                      Personas adicionales (Seguro)
                    </label>
                    <input
                      type="number"
                      min="0"
                      className="form-control bg-light border-0 py-2 shadow-none"
                      name="adicionales_seguro"
                      value={socioEditar.adicionales_seguro || 0}
                      disabled={!socioEditar.tiene_seguro_vida}
                      onChange={(e) =>
                        setSocioEditar((prev) => ({
                          ...prev,
                          adicionales_seguro: Number(e.target.value),
                        }))
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted">Paga Núcleo</label>
                    <select
                      className="form-select bg-light border-0 py-2 shadow-none"
                      name="paga_nucleo"
                      value={!!socioEditar.paga_nucleo}
                      onChange={(e) =>
                        setSocioEditar((prev) => ({
                          ...prev,
                          paga_nucleo: e.target.value === "true",
                        }))
                      }
                    >
                      <option value={false}>No</option>
                      <option value={true}>Sí</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-top-0 pb-4 px-4 gap-2">
                <button className="btn btn-light border px-4" onClick={() => setMostrarModalEditar(false)}>Cancelar</button>
                <button className="btn btn-primary px-4 fw-bold" onClick={guardarEdicionSocio}>Guardar Cambios</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionSocios;